<template>
  <ion-segment mode="md" scrollable :value="value" @ionChange="segmentChanged($event)" style="margin: 0">
    <template v-for="(item,index) in navigation">
      <ion-segment-button mode="md" :value="item.route" :disabled="item.disabled">
        <ion-label>{{ item.title }}</ion-label>
      </ion-segment-button>
    </template>
  </ion-segment>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: 'LoyaltySegment',
    props: ['value'],
    computed: {
      ...mapState({
        navigation: state => state.config.navigation ? state.config.navigation.loyalty : [],
      }),
    },
    methods: {
      segmentChanged(e) {
        console.log('LoyaltySegment', e.target.value)
        let routeName = e.target.value;
        this.$router.push({name: routeName}).catch(err => {})
      }
    }
  }
</script>